import QueryBase from './QueryBase';
import log from 'loglevel';
/**
 *
 * Created Date: 2019-07-01, 16:56:22 (zhenliang.sun)
 * Last Modified: 2019-11-04, 17:25:11 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

export default class QueryBoardSeek extends QueryBase {
  constructor() {
    super();
  }

  async query(start, end) {
    let result = await this.dbController.select([
      { key: 'uid', value: 0, compare: '>=' },
      { key: 'time', value: end, compare: '<', optional: true },
      { key: 'cid', value: this.cid, compare: '=' }
    ]);

    log.info(`起始时间:${start}, 终止时间:${end}, 找到了${result.length}条数据`);
    return result;
  }
}
